/**
 * List
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class CommentOrder {

	public onReload: any;

	private $parent: any;

	private articleId: string;

	private _id: string;

	private orderType: string;

	private DESC = 'desc';

	private ASC = 'asc';

	private GOOD = 'good';

	private IS_ACTIVE = 'is-active';

	constructor( $parent: any, articleId: string ) {

		const params = Util.getParams();

		this.$parent = $parent;

		this._id = this.$parent.attr( 'id' );

		this.articleId = articleId || params.articleId;

		this.orderType = Config.commentOrderByDefault;

		this.onReload = new Util.Observer();

		this.addEvent();
	}

	public setActiveOrderType( orderType = Config.commentOrderByDefault ) {

		let activated = '';

		if ( orderType === this.DESC ) {
			activated = this.DESC;
		} else if ( orderType === this.GOOD ) {
			activated = this.GOOD;
		} else if ( orderType === this.ASC ) {
			activated = this.ASC;
		}

		this.setActive( activated );
	}

	public setActive( orderType: string ) {
		jQuery( `#${this._id} .comment-order button` ).removeClass( this.IS_ACTIVE );
		jQuery( `#${this._id} .comment-order button.co-btn-${orderType}` ).addClass( this.IS_ACTIVE );
	}

	public setUI() {
		let template = `
			<div class="comment-order">
				<button class="co-btn co-btn-${this.GOOD}">${Config.L10N.btn_orderby_good}</button>
				<button class="co-btn co-btn-${this.DESC}">${Config.L10N.btn_orderby_desc}</button>
				${( Config.isCommentOrderByAsc ) ? `<button class="co-btn co-btn-${this.ASC}">${Config.L10N.btn_orderby_asc}</button>` : ``}
				<button class="co-btn co-btn-reload"><i class="fe-icon-reload"></i></button>
			</div>`;

		if ( !Config.isShowCommentOrderType ) {
			template = '';
		}

		return template;
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .co-btn-${this.DESC}`, ( evt ) => {
			this.onReload.emit( this.DESC );
			// this.setActive( this.DESC );
		});

		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .co-btn-${this.ASC}`, ( evt ) => {
			this.onReload.emit( this.ASC );
			// this.setActive( this.ASC );
		});

		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommentCommonWrap .co-btn-${this.GOOD}`, ( evt ) => {
			this.onReload.emit( this.GOOD );
			// this.setActive( this.GOOD );
		});
	}
}

export default CommentOrder;
